package com.isaias.fyattravel.shared.visa.util

import com.isaias.fyattravel.shared.Visa.CountryCodes

/**
 * Helper object to access CountryCodes functionality
 * This wrapper ensures the CountryCodes object is accessible from feature modules
 */
object CountryCodesHelper {
    /**
     * Get country name from country code
     */
    fun getCountryName(countryCode: String): String? {
        return CountryCodes.getCountryName(countryCode)
    }

    /**
     * Get country code from country name
     */
    fun getCountryCode(countryName: String): String? {
        return CountryCodes.getCountryCode(countryName)
    }

    /**
     * Search countries by query
     */
    fun searchCountries(query: String): List<Pair<String, String>> {
        return CountryCodes.searchCountries(query)
    }

    /**
     * Get all countries
     */
    val countries: Map<String, String>
        get() = CountryCodes.countries
}
